export default __webpack_public_path__ + "static/media/Mark-6-Suit-09.e4e13ff5.jpg";